import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { NoteAlertType } from '@src/Application/Types/ComponentTypes'

import { Wrapper } from './NoteAlert.styled'

export const NoteAlert = ({ note }: NoteAlertType): JSX.Element => {
    return (
        <Wrapper>
            <Html content={note.data.childMarkdownRemark.html} />
        </Wrapper>
    )
}
